import { InjectionToken, Signal, computed } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { UserService } from '@at/user';
import { TripApiService } from '../api';
import { createFetchState, FetchState, getFetchInitialState } from '@at/shared';
import { map } from 'rxjs';
import { Trip } from '../entities';

export interface TripService {
  isOwner: Signal<boolean>;
  ownerId: Signal<string | undefined>;
  state: Signal<FetchState<Trip>>;
  trip: Signal<Trip | undefined>;
  tripId: Signal<string | undefined>;
}

export const CURRENT_TRIP = new InjectionToken<TripService>('CURRENT_TRIP');

export const CurrentTripProvider = {
  provide: CURRENT_TRIP,
  useFactory: (api: TripApiService, route: ActivatedRoute, userService: UserService) => {
    const user = toSignal(userService.user$);
    const state = toSignal(
      createFetchState({
        fetchCall: () =>
          api.getTrip(route.snapshot.params['id']).pipe(map((response) => response.trip)),
      }),
      { initialValue: getFetchInitialState<Trip>() },
    );
    const trip = computed(() => state()?.data ?? undefined);
    const isOwner = computed(() => {
      const usr = user();
      const trp = trip();
      if (!usr || !trp) return false;
      return trp.owner === usr.userId;
    });
    const tripId = computed(() => trip()?.tripId);
    const ownerId = computed(() => trip()?.owner);

    return {
      isOwner,
      state,
      trip,
      tripId,
      ownerId,
    } satisfies TripService;
  },
  deps: [TripApiService, ActivatedRoute, UserService],
};

export const provideTrip = () => CurrentTripProvider;
